import { render, staticRenderFns } from "./subscribe_message.vue?vue&type=template&id=ba5f1a74"
import script from "./subscribe_message.vue?vue&type=script&lang=js"
export * from "./subscribe_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports